import React from "react";

import { Button, Col, Form, Input, InputNumber, Row } from "antd";

const CooperateOptionComponent = ({
  product,
  cooperate,
  setCooperate,
  productOptions,
  setProductOptions,
  setExampleShow,
  setExampleTitle,
  optionList,
}) => {
  const handleExampleModal = () => {
    setExampleShow(true);
    setExampleTitle({
      id: "cooperate_price_1",
      title: "기존 판매가",
    });
  };

  /**
   * 옵션 추가
   */
  const addOption = () => {
    setProductOptions([
      ...productOptions,
      {
        option_title: "[N%, 1+1] N박스 (N개월분)",
        price_2: 0,
        option_quantity: 1,
        conversion_price_per_unit: null,
        quantity: 999,

        // 태그 추가
        tag_name: null,
        tag_background_color: null,
        tag_text_color: null,
      },
    ]);
  };

  /**
   * 옵션 삭제
   */
  const deleteOptions = (index, option) => {
    let currList = [...productOptions];
    currList.splice(index, 1);
    // if (match.params.hasOwnProperty("id")) {
    // 	if (option.hasOwnProperty("id")) {
    // 		setDeleteOption([...deleteOption, option.id]);
    // 	}
    // }
    setProductOptions(currList);
  };

  /**
   * 옵션 handleChange
   */
  const handleOptionChange = (e, index) => {
    const { name, value } = e.target;
    let currOptions = [...productOptions];
    currOptions[index][name] = value;
    setProductOptions(currOptions);
  };

  /**
   * 옵션 handlePriceChange
   */
  const handleOptionPriceChange = (value, name, index) => {
    let currOptions = [...productOptions];
    if (name === "price_1") {
      if (
        productOptions[index].discount !== "" &&
        productOptions[index].discount !== "0" &&
        value !== null &&
        value !== 0
      ) {
        currOptions[index]["price_2"] =
          value - value * (parseInt(productOptions[index].discount) / 100);
      } else if (
        !productOptions[index].discount &&
        value !== null &&
        value !== 0
      ) {
        currOptions[index]["price_2"] = value;
      }
    } else if (name === "price_2") {
      if (
        productOptions[index].price_1 &&
        productOptions[index]?.price_1 !== null &&
        productOptions[index]?.price_1 !== 0 &&
        value !== null
      ) {
        currOptions[index]["discount"] = Math.floor(
          ((productOptions[index].price_1 - value) /
            productOptions[index].price_1) *
            100,
        );
      }
    }
    currOptions[index][name] = value;
    setProductOptions(currOptions);
  };

  return (
    <>
      <Row
        className="product-register-border-box"
        wrap={false}
        style={{ marginTop: 20 }}
      >
        <span className="product-register-box-title">공구 옵션</span>
        <span className="product-register-box-sign">*</span>
      </Row>
      <div
        className="product-register-border-box"
        style={{
          borderTop: 0,
          padding: "25px 25px 40px",
          height: "fit-content",
        }}
      >
        <Form.Item
          className="product-option-wrap"
          label={
            <span>
              기존 판매가{" "}
              <span
                className="product-register-box-subtitle"
                style={{
                  fontSize: "0.9em",
                  cursor: "pointer",
                  borderBottom: "solid 1px #117ffa",
                  margin: 0,
                }}
                onClick={handleExampleModal}
              >
                예시
              </span>
            </span>
          }
          labelAlign="left"
          colon={false}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 3 }}
        >
          <div
            className="product-option-row-wrap"
            style={{ display: "flex", alignItems: "center", gap: 6 }}
          >
            <InputNumber
              style={{ margin: 0 }}
              formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              name="price_1"
              disabled={!product && !optionList.length}
              value={cooperate.price_1}
              onChange={(value) =>
                setCooperate({ ...cooperate, price_1: value })
              }
            />
            <span>원</span>
          </div>
        </Form.Item>
        <Form.Item
          className="product-option-wrap"
          label={`옵션 목록(${productOptions?.length}개)`}
          labelAlign="left"
          colon={false}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 21 }}
        >
          <div
            className="product-option-list-wrap"
            style={{ overflowX: "auto", position: "relative" }}
            key={`product-option-list-wrap-${productOptions?.length}`}
          >
            <Row
              wrap={false}
              gutter={8}
              className="product-option-text"
              style={{ marginBottom: 15 }}
            >
              <img
                className="product-option-button"
                alt={"product-option-button"}
                style={{
                  width: "22px",
                  height: "22px",
                  cursor: "pointer",
                  visibility: "hidden",
                }}
                src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}
              />
              <Col flex="none">
                <div
                  className="product-option-button-wrap"
                  style={{
                    width: "auto",
                    minWidth: "auto",
                  }}
                />
              </Col>
              <Col span={5} style={{ textAlign: "center" }}>
                공구 옵션명
              </Col>
              <Col span={3} style={{ textAlign: "center" }}>
                공구가
              </Col>
              <Col span={3} style={{ textAlign: "center" }}>
                구매 수량
              </Col>
              <Col span={5} style={{ textAlign: "center" }}>
                박스 당 가격
              </Col>
              {/* 태그 */}
              <Col span={10} style={{ textAlign: "center" }}>
                옵션 태그
              </Col>
              {/* 태그 끝 */}
            </Row>
            {productOptions.map((option, index) => {
              return (
                <div key={`product-option-${index}`}>
                  <Row
                    wrap={false}
                    gutter={8}
                    className="product-option-row-wrap"
                  >
                    <Col flex="none" style={{ textAlign: "end" }}>
                      <div
                        className="product-option-button-wrap"
                        style={{
                          width: "auto",
                          minWidth: "auto",
                        }}
                      >
                        {productOptions?.length !== 1 ? (
                          <img
                            className="product-option-button"
                            alt={"product-option-button"}
                            style={{
                              width: "22px",
                              height: "22px",
                              cursor: "pointer",
                            }}
                            src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}
                            onClick={() => deleteOptions(index, option)}
                          />
                        ) : (
                          <img
                            className="product-option-button"
                            alt={"product-option-button"}
                            style={{
                              width: "22px",
                              height: "22px",
                              cursor: "pointer",
                              visibility: "hidden",
                            }}
                            src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}
                          />
                        )}
                      </div>
                    </Col>
                    <Col span={5}>
                      <Input
                        name="option_title"
                        placeholder="옵션명을 입력해주세요."
                        value={option.option_title}
                        disabled={!product && !optionList.length}
                        onChange={(e) => handleOptionChange(e, index)}
                      />
                    </Col>
                    <Col span={3}>
                      <InputNumber
                        formatter={(value) =>
                          value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        min={0}
                        value={option.price_2}
                        onChange={(value) =>
                          handleOptionPriceChange(value, "price_2", index)
                        }
                        disabled={!product && !optionList.length}
                      />
                    </Col>
                    <Col span={3}>
                      <InputNumber
                        formatter={(value) =>
                          value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        min={1}
                        name="option_quantity"
                        value={option.option_quantity}
                        onChange={(value) =>
                          handleOptionPriceChange(
                            value,
                            "option_quantity",
                            index,
                          )
                        }
                        // onChange={(e) => handleOptionChange(e, index)}
                        disabled={!product && !optionList.length}
                      />
                    </Col>
                    <Col span={6}>
                      <InputNumber
                        formatter={(value) =>
                          value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                        name="conversion_price_per_unit"
                        placeholder="박스 당 가격"
                        value={option.conversion_price_per_unit}
                        onChange={(value) =>
                          handleOptionPriceChange(
                            value,
                            "conversion_price_per_unit",
                            index,
                          )
                        }
                        disabled={!product && !optionList.length}
                      />
                    </Col>

                    {/* 태그 추가 */}
                    <Col span={8}>
                      <Row gutter={[8, 0]}>
                        <Col span={8}>
                          <Input
                            name="tag_name"
                            placeholder="태그 이름"
                            value={option.tag_name}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>
                        <Col span={8}>
                          <Input
                            name="tag_background_color"
                            placeholder="태그 배경색"
                            value={option.tag_background_color}
                            onChange={(e) => handleOptionChange(e, index)}
                            disabled={!option.tag_name}
                          />
                        </Col>
                        <Col span={8}>
                          <Input
                            name="tag_text_color"
                            placeholder="태그 글자색"
                            value={option.tag_text_color}
                            onChange={(e) => handleOptionChange(e, index)}
                            disabled={!option.tag_name}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
          <Button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "fit-content",
              margin: "1rem auto",
              cursor: product ? "pointer" : "inherit",
            }}
            onClick={addOption}
            disabled={!product && !optionList.length}
          >
            <img
              style={{ width: "0.9rem", height: "0.9rem", marginRight: 5 }}
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/plus.png`}
              alt={`product-option-add`}
              className="product-option-button"
              onClick={addOption}
            />
            <p style={{ margin: 0 }}>옵션추가</p>
          </Button>
        </Form.Item>
      </div>
    </>
  );
};

export default CooperateOptionComponent;
